// extracted by mini-css-extract-plugin
export default {"catview":"categoryview_catview__0cqyz","title":"categoryview_title__Atcy+","wrapper":"categoryview_wrapper__k5ORl","gridView":"categoryview_gridView__BvgEx"};